import { useQuery, CombinedError } from 'urql';
import { GetSocialAnalyticsMembersQuery } from '@frontend/gql/social/graphql';
import { getAllSocialAnalyticsMembers } from '../graphql';
import { GraphQLQueryVariables } from './useSummaryData';

interface UseTopCreatorsDataProps {
  clientId: string | undefined;
  queryVariables: GraphQLQueryVariables;
  pause?: boolean;
}

export interface UseTopCreatorsDataReturn {
  data: GetSocialAnalyticsMembersQuery | undefined;
  fetching: boolean;
  error?: CombinedError;
  refetch: (options?: { requestPolicy?: 'cache-first' | 'cache-only' | 'network-only' | 'cache-and-network' }) => void;
}

export const useTopCreatorsData = ({
  clientId,
  queryVariables,
  pause = false,
}: UseTopCreatorsDataProps): UseTopCreatorsDataReturn => {
  const [{ data, fetching, error }, refetch] = useQuery({
    query: getAllSocialAnalyticsMembers,
    variables: {
      clientId: clientId || '',
      startDate: queryVariables.startDate || '',
      endDate: queryVariables.endDate || '',
      postTypes: queryVariables.postTypes || [],
      includeEstimates: queryVariables.includeEstimates ?? false,
      networks: queryVariables.networks || [],
      projectIds: queryVariables.projectIds,
      groupIds: queryVariables.groupIds,
      memberIds: queryVariables.memberIds,
      segments: queryVariables.segments,
      paging: {
        limit: 10
      },
      sort: {
        prop: 'engagements',
        ordering: 'DESC'
      }
    },
    pause: !clientId || pause,
  });

  return {
    data,
    fetching,
    error,
    refetch,
  };
};
